import { render, staticRenderFns } from "./hqnotice-problem-photo.vue?vue&type=template&id=4d66481a&scoped=true&"
import script from "./hqnotice-problem-photo.vue?vue&type=script&lang=js&"
export * from "./hqnotice-problem-photo.vue?vue&type=script&lang=js&"
import style0 from "./hqnotice-problem-photo.vue?vue&type=style&index=0&id=4d66481a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d66481a",
  null
  
)

export default component.exports